<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="30px"
    viewBox="0 0 20 30"
    style="enable-background:new 0 0 50 50;"
    xml:space="preserve"
  >
    <rect x="0" y="5.57933" width="4" height="18.8413" :fill="color" opacity="0.2">
      <animate
        attributeName="opacity"
        attributeType="XML"
        values="0.2; 1; .2"
        begin="0s"
        dur="1s"
        repeatCount="indefinite"
      ></animate>
      <animate
        attributeName="height"
        attributeType="XML"
        values="10; 20; 10"
        begin="0s"
        dur="1s"
        repeatCount="indefinite"
      ></animate>
      <animate
        attributeName="y"
        attributeType="XML"
        values="10; 5; 10"
        begin="0s"
        dur="1s"
        repeatCount="indefinite"
      ></animate>
    </rect>
    <rect x="8" y="8.07933" width="4" height="13.8413" :fill="color" opacity="0.2">
      <animate
        attributeName="opacity"
        attributeType="XML"
        values="0.2; 1; .2"
        begin="0.15s"
        dur="1s"
        repeatCount="indefinite"
      ></animate>
      <animate
        attributeName="height"
        attributeType="XML"
        values="10; 20; 10"
        begin="0.15s"
        dur="1s"
        repeatCount="indefinite"
      ></animate>
      <animate
        attributeName="y"
        attributeType="XML"
        values="10; 5; 10"
        begin="0.15s"
        dur="1s"
        repeatCount="indefinite"
      ></animate>
    </rect>
    <rect x="16" y="9.42067" width="4" height="11.1587" :fill="color" opacity="0.2">
      <animate
        attributeName="opacity"
        attributeType="XML"
        values="0.2; 1; .2"
        begin="0.3s"
        dur="1s"
        repeatCount="indefinite"
      ></animate>
      <animate
        attributeName="height"
        attributeType="XML"
        values="10; 20; 10"
        begin="0.3s"
        dur="1s"
        repeatCount="indefinite"
      ></animate>
      <animate
        attributeName="y"
        attributeType="XML"
        values="10; 5; 10"
        begin="0.3s"
        dur="1s"
        repeatCount="indefinite"
      ></animate>
    </rect>
  </svg>
</template>

<script>
export default {
  props: ["color"]
};
</script>
